import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HelpdeskRulesAPI } from "../../../api/helpdeskRules";

export default function RulesListPage() {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  async function loadRules() {
    try {
      const data = await HelpdeskRulesAPI.list();
      setRules(data.rules || []);
    } finally {
      setLoading(false);
    }
  }

  async function toggleRule(rule) {
    if (rule.enabled) {
      await HelpdeskRulesAPI.disable(rule.id);
    } else {
      await HelpdeskRulesAPI.enable(rule.id);
    }
    loadRules();
  }

  useEffect(() => {
    loadRules();
  }, []);

  if (loading) return <div>Loading rules…</div>;

  return (
    <div className="p-6 space-y-4">
      <div className="flex justify-between items-center">
        <h1 className="text-xl font-semibold">Helpdesk Rules</h1>
        <button
          onClick={() => navigate("/helpdesk/settings/rules/new")}
          className="px-4 py-2 bg-blue-600 text-white rounded"
        >
          New rule
        </button>
      </div>

      <table className="w-full border">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2 text-left">Name</th>
            <th className="p-2">Trigger</th>
            <th className="p-2">Scope</th>
            <th className="p-2">Enabled</th>
            <th className="p-2">Delete</th>
          </tr>
        </thead>
        <tbody>
          {rules.map((r) => (
            <tr key={r.id} className="border-t hover:bg-gray-50">
              <td
                className="p-2 cursor-pointer text-blue-600"
                onClick={() =>
                  navigate(`/helpdesk/settings/rules/${r.id}`)
                }
              >
                {r.name}
              </td>
              <td className="p-2 text-center">{r.event_type}</td>
              <td className="p-2 text-center">{r.scope_type}</td>
              <td className="p-2 text-center">
                <input
                  type="checkbox"
                  checked={r.enabled}
                  onClick={(e) => e.stopPropagation()}
                  onChange={() => toggleRule(r)}
                />
              </td>
              <td className="p-2 text-center">
                <button
                  onClick={async (e) => {
                    e.stopPropagation();

                    if (!window.confirm("Delete this rule?")) return;

                    await HelpdeskRulesAPI.delete(r.id);
                    loadRules();
                  }}
                  className="text-red-600"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}